var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.locationClass,attrs:{"id":"toast-container","aria-live":"polite","role":"alert"}},_vm._l((_vm.toasts),function(toast,index){return _c('Toast',{key:index,attrs:{"toast":toast},on:{"click":function($event){return _vm.removeToast(toast)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }